import Layout from "../../../hocs/Layout";

function PrivacyPolicy() {
  return (
    <Layout products={true}>
      <div className="bg-white min-h-screen py-8">
        <div className="max-w-6xl mx-auto px-4">
          <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
          <div className="text-left">
            <p>Last updated: January 20, 2025</p>
            <p>
              This Privacy Policy describes our policies and procedures on the
              collection, use, and disclosure of your information when you use
              our service, as well as your privacy rights and how the law
              protects you. We are committed to protecting your privacy and
              ensuring that your personal data is treated in accordance with
              applicable regulations, including the General Data Protection
              Regulation (GDPR) and the California Consumer Privacy Act (CCPA).
            </p>
            <h3 className="text-xl font-bold mt-4">
              Your Rights under GDPR and CCPA
            </h3>
            <h4 className="text-lg font-bold mt-2">
              GDPR (for European Union residents)
            </h4>
            <ul className="list-disc list-inside">
              <li>
                <strong>Right of access:</strong> You can request access to and
                obtain a copy of your personal data that we hold.
              </li>
              <li>
                <strong>Right to rectification:</strong> You can request
                corrections to inaccurate or incomplete data.
              </li>
              <li>
                <strong>Right to erasure:</strong> You can request the deletion
                of your personal data when it is no longer necessary for the
                purposes collected.
              </li>
              <li>
                <strong>Right to restrict processing:</strong> You can request
                the limitation of the processing of your data under certain
                conditions.
              </li>
              <li>
                <strong>Right to data portability:</strong> You can request a
                copy of your data in a structured, commonly used, and
                machine-readable format.
              </li>
              <li>
                <strong>Right to object:</strong> You can object to the
                processing of your data under certain circumstances.
              </li>
              <li>
                <strong>Right to withdraw consent:</strong> When processing is
                based on your consent, you have the right to withdraw it at any
                time.
              </li>
              <li>
                <strong>Right to lodge a complaint:</strong> You can lodge a
                complaint with a supervisory authority if you believe that the
                processing of your data violates the GDPR.
              </li>
            </ul>
            <h4 className="text-lg font-bold mt-2">
              CCPA (for California residents)
            </h4>
            <ul className="list-disc list-inside">
              <li>
                <strong>Right to know:</strong> You can request information
                about the collection and use of your personal data in the last
                12 months.
              </li>
              <li>
                <strong>Right to delete:</strong> You can request the deletion
                of your personal data, subject to legal exceptions.
              </li>
              <li>
                <strong>Right to opt-out:</strong> You can request that we do
                not sell your personal data (we currently do not sell personal
                data).
              </li>
              <li>
                <strong>Right to non-discrimination:</strong> You will not
                receive discriminatory treatment for exercising your rights
                under the CCPA.
              </li>
            </ul>
            <p>
              To exercise your rights under the CCPA, contact us through the
              details provided below. We will respond to verified requests
              within the timeframes established by law.
            </p>
            <h3 className="text-xl font-bold mt-4">
              Collection and Use of Personal Data
            </h3>
            <p>
              We use your personal data to provide and improve the service. The
              legal basis for data processing under the GDPR may be your
              consent, the necessity for the performance of a contract,
              compliance with legal obligations, or our legitimate business
              interests.
            </p>
            <p>Personal data collected may include:</p>
            <ul className="list-disc list-inside">
              <li>
                Identifiers such as name, email address, shipping address, phone
                number, and IP address.
              </li>
              <li>
                Commercial information, such as records of services purchased or
                considered.
              </li>
              <li>
                Internet or electronic network activity, such as browsing
                history and interactions with our service.
              </li>
              <li>Geolocation data.</li>
              <li>
                Information received directly from you in surveys, contests, or
                promotions.
              </li>
              <li>
                Photos and information from your device's camera or image
                library.
              </li>
            </ul>
            <h3 className="text-xl font-bold mt-4">Data Security</h3>
            <p>
              We implement appropriate technical and organizational measures to
              protect your personal data. While no method of transmission over
              the Internet is 100% secure, we strive to ensure the security of
              your information.
            </p>
            <h3 className="text-xl font-bold mt-4">Children's Privacy</h3>
            <p>
              Our service is not intended for individuals under the age of 13.
              We do not knowingly collect personal data from children under this
              age. If you become aware that a minor has provided us with
              information, please contact us to have it removed.
            </p>
            <h3 className="text-xl font-bold mt-4">
              Changes to this Privacy Policy
            </h3>
            <p>
              We may update this Privacy Policy from time to time. When we do,
              we will notify you of any changes by posting a prominent notice on
              our service. Please review this policy periodically for updates.
            </p>
            <h3 className="text-xl font-bold mt-4">Contact Us</h3>
            <p>
              If you have any questions about this Privacy Policy or wish to
              exercise your rights, please contact us at:
            </p>
            <ul className="list-disc list-inside">
              <li>Email: support@hitori.ai</li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default PrivacyPolicy;
